module.exports = __webpack_public_path__ + "img/102.d3ec812f.png";